import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import RefreshIcon from '@material-ui/icons/Refresh';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { JupiterTheme } from '../../theme/types';
import { AutocompleteMultiSelectOptionsHeaderProps } from './types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      position: 'relative',
      height: '24px',
    },
    refreshButton: {
      fontSize: theme.typography.pxToRem(18),
      marginLeft: 'calc(100% - 24px)', // float: right causes problems with list items
      marginTop: '-2px',
    },
    linearProgress: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
    },
    linearProgressHidden: {
      display: 'none',
    },
  })
);

const AutocompleteMultiSelectOptionsHeader = ({
  refetchable,
  onRefetch,
  loading,
}: AutocompleteMultiSelectOptionsHeaderProps) => {
  const classes = useStyles();
  if (!refetchable) return null;

  return (
    <div className={classes.root}>
      <div>
        <IconButton
          className={classes.refreshButton}
          size="small"
          onClick={onRefetch}
          disabled={loading}
        >
          <RefreshIcon className={classes.refreshButton} />
        </IconButton>
      </div>
      <LinearProgress
        className={clsx(
          classes.linearProgress,
          !loading && classes.linearProgressHidden
        )}
        color="primary"
      />
    </div>
  );
};

export default AutocompleteMultiSelectOptionsHeader;
